import { RemansoFigure } from "@/components/Brand";
import { CrisisNote } from "@/components/CrisisNote";
import { RemansoControls, RemansoThread } from "@/components/RemansoThread";
import { RouteChooser } from "@/components/RouteChooser";
import { useRemanso } from "@/context/RemansoContext";

export const RemansoMargin = () => {
  const { estado, openInfo } = useRemanso();
  return (
  <aside
    data-testid="remanso-margin"
    className="hidden lg:flex flex-col gap-5 overflow-hidden sticky top-8 h-[calc(100vh-4rem)] rounded-[24px] bg-superficie px-6 py-7 [@media(max-height:760px)]:py-5 [@media(max-height:760px)]:gap-4"
  >
    <div className="settle shrink-0 flex items-start gap-5">
      <button type="button" className="shrink-0 rounded-[24px]" aria-label="Conocer a los Remansos" onClick={() => openInfo("historia")} data-testid="remanso-margin-figure-button">
        <RemansoFigure estado={estado} height={96} className="breathe" testId="remanso-margin-figure" />
      </button>
      <div className="pt-1 min-w-0">
        <button type="button" className="font-serif text-[28px] leading-tight text-tinta hover:text-acento-texto transition-colors" onClick={() => openInfo("historia")} data-testid="remanso-name">Remanso</button>
        <p className="text-[15px] leading-snug text-sec mt-1.5 [@media(max-height:760px)]:hidden">Acompaña sin aconsejar. Te pregunta para que sigas escribiendo.</p>
      </div>
    </div>
    <div className="shrink-0">
      <RouteChooser prefix="margin" />
    </div>
    <div className="flex-1 min-h-[72px] overflow-y-auto -mx-1 px-1" data-testid="margin-thread-scroll" data-thread-scroll>
      <RemansoThread prefix="margin" />
    </div>
    <div className="shrink-0">
      <RemansoControls prefix="margin" />
    </div>
    <div className="shrink-0 pt-5 border-t border-linea">
      <CrisisNote testId="remanso-margin-crisis-note" />
    </div>
  </aside>
  );
};
